import { Trans } from "react-i18next";

export default function ChallengeInnointelSearchContent({
  ownerChallenge,
  status,
}) {
  return (
    <Trans
      i18nKey={
        status === "success" ? "notifications.challengeInnointelSearchSuccess"
        : status === "pending" ?
          "notifications.challengeInnointelSearch"
        : "notifications.challengeInnointelSearchFailed"
      }
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
    />
  );
}
